export default __webpack_public_path__ + "static/media/05_Auctioneers-Commercial-EschweilerPhotography_M1A6711.f95be9ab.jpg";